var _defs, _circle, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg72Ms9(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#03142a;}.cls-4{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16,
    cy: 16,
    r: 8
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 16,
    cy: 16,
    r: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16,9c3.87,0,7,3.13,7,7h2c0-4.97-4.03-9-9-9v2Zm-7,7c0-3.87,3.13-7,7-7v-2c-4.97,0-9,4.03-9,9h2Zm7,7c-3.87,0-7-3.13-7-7h-2c0,4.97,4.03,9,9,9v-2Zm7-7c0,3.87-3.13,7-7,7v2c4.97,0,9-4.03,9-9h-2Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18.79,13.12v.75c0,.35-.24,.62-.54,.62s-.54-.28-.54-.62v-.12h-1.19s0,.03,0,.05v4.7h.54c.24,0,.43,.22,.43,.5s-.19,.5-.43,.5h-2.14c-.24,0-.43-.22-.43-.5s.19-.5,.43-.5h.54v-4.7s0-.03,0-.05h-1.19v.12c0,.35-.24,.62-.54,.62s-.54-.28-.54-.62v-.75c0-.35,.24-.62,.54-.62h4.5c.3,0,.54,.28,.54,.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg72Ms9);
export default __webpack_public_path__ + "static/media/72-ms-9.b2729ae37dbc9bc2a706388bee8f1189.svg";
export { ForwardRef as ReactComponent };